import React, { FunctionComponent, useState, ChangeEvent } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import createPdf from "./createPdf";
import { JobExportPdfModalType } from "../types/exportModalTypes";
import PdfExportPage from "./PdfExportPage";
import Modal from "../../legacy/Modal";
import Checkbox from "../../library/Checkbox";
import Button from "../../library/Button";
import jobProfileType from "../types/jobProfileType";
import { ModalBody, FieldSet, Column, Note } from "../styles/export-pdf-styles";

const ExportPdfModal: FunctionComponent<JobExportPdfModalType> = ({
  toggleModal,
  jobProfile,
  isPortalUser,
  recruiterCompanyName,
}) => {
  const [{ salary, fee, agencyBriefing, benefits }, setOptions] = useState({
    salary: true,
    fee: false,
    agencyBriefing: false,
    benefits: true,
  });

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.persist();
    setOptions((state) => ({ ...state, [e.target.name]: e.target.checked }));
  };

  const brand = isPortalUser ? "Portal" : "Hiring Hub";
  const pdfFileName = `${brand} - ${jobProfile.jobTitle} - Job profile.pdf`;

  return (
    <>
      <Modal closeFunction={toggleModal} title="Export Job Profile to PDF">
        <Button
          icon
          id="close-modal-button"
          name="close modal"
          type="button"
          aria-label="Close Modal"
          onClick={() => toggleModal()}
        >
          <FontAwesomeIcon icon={faTimes} />
        </Button>
        <ModalBody>
          <Note>
            Please select the fields you like in your download. Please do not
            use this download to advertise the role as the employer’s details
            may be present in the text.
          </Note>
          <FieldSet>
            <Column>
              <Checkbox
                checked={salary}
                label="Salary"
                name="salary"
                onChange={onChange}
              />
              <Checkbox
                checked={fee}
                label="Recruitment Fee"
                name="fee"
                onChange={onChange}
              />
            </Column>
            <Column>
              <Checkbox
                checked={agencyBriefing}
                label="Agency Briefing"
                name="agencyBriefing"
                onChange={onChange}
              />
              <Checkbox
                checked={benefits}
                label="Benefits"
                name="benefits"
                onChange={onChange}
              />
            </Column>
          </FieldSet>
          <Button
            type="button"
            primary
            centered
            name="export to PDF"
            onClick={() => createPdf("job-profile-export", pdfFileName)}
          />
        </ModalBody>
      </Modal>
      <PdfExportPage
        jobProfile={jobProfile}
        isPortalUser={isPortalUser}
        salarySelected={salary}
        feeSelected={fee}
        agencyBriefingSelected={agencyBriefing}
        benefitsSelected={benefits}
        recruiterCompanyName={recruiterCompanyName}
      />
    </>
  );
};

ExportPdfModal.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  jobProfile: jobProfileType.isRequired,
  isPortalUser: PropTypes.bool.isRequired,
  recruiterCompanyName: PropTypes.string.isRequired,
};

export default ExportPdfModal;
